import {https, httpsFile} from './http.js';

export function storeRequest(data){
    return https().post(`storeIntegratedModuleRequest`,data);
}

export function saveRequest(data){
    return https().post(`saveIntegratedModuleRequest`,data);
}

// export function updateGoodsIssue(data){
//     return https().post(`updateGoodsIssue`,data);
// }
// export function manualExport(data){
//     return https().post(`manualExport`,data);
// }
//
// export function postGoodsIssue(data){
//     return https().post(`postGoodsIssue`,data);
// }
// export function cancelGoodsIssue(data){
//     return https().post(`cancelGoodsIssue`,data);
// }
//
export function index(page, currentpage,sortby,sortdir, search,plant) {
    return httpsFile().get(`IntegratedModule?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}`);
}

export function show(id){
    return https().get(`IntegratedModule/${id}`);
}
export function cancelRequest(id){
    return https().get(`cancelRequestDraft?id=${id}`);
}
